import styled from 'styled-components';
import { styles, mixins } from '4all-ui/styles';
import { container } from '../../styles/mixins';

export const Container = styled.div``;

export const Content = styled.div`
  ${container()}

  .select__control {
    ${mixins.flexPosition({ align: 'center' })}
  }
`;

export const Title = styled.h1`
  ${mixins.fontStyle(styles.colors.GRAY_DARKER, styles.fontSizes.SIZE_1, styles.fontWeights.NORMAL)}
  margin: 0;
  margin-bottom: 30px;
  padding-top: 50px;
`;

export const BoxContent = styled.div`
  ${mixins.flexPosition({ align: 'center', justify: 'space-between' })}
`;

export const FieldsContainer = styled.div`
  width: 100%;
  ${mixins.flexPosition({ justify: 'space-between' })}
  margin-top: 50px;
`;

export const Fields = styled.div`
  width: 100%;
  padding-left: 50px;
`;



// WEBPACK FOOTER //
// ./src/screens/CreateProduct/style.js